import { render, staticRenderFns } from "./k-tag-input.vue?vue&type=template&id=df996a18&"
import script from "./k-tag-input.vue?vue&type=script&lang=ts&"
export * from "./k-tag-input.vue?vue&type=script&lang=ts&"
import style0 from "./k-tag-input.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports